// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".scene-section__transition-bar-popover {\n  top: -32px !important;\n}\n", "",{"version":3,"sources":["webpack://./resources/js/components/editor/SceneSection.vue"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB","sourcesContent":[".scene-section__transition-bar-popover {\n  top: -32px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
